import { useState } from 'react';
import { APP } from '../tokens';

const F = APP.fontFamily;
const ACCENT = '#6366F1';

interface CoTClarifyCardProps {
  question: string;
  options?: string[];
  allowFreeInput?: boolean;
  onAnswer: (answer: string) => void;
  onCancel: () => void;
}

export default function CoTClarifyCard({
  question,
  options,
  allowFreeInput = true,
  onAnswer,
  onCancel,
}: CoTClarifyCardProps) {
  const [input, setInput] = useState('');

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 6,
        paddingBlock: 8,
        paddingInline: 10,
        gap: 8,
        backgroundColor: `${ACCENT}0F`,
        border: `1px solid ${ACCENT}26`,
      }}
    >
      {/* Question */}
      <span
        style={{
          fontSize: 11,
          fontWeight: 500,
          color: APP.textPrimary,
          lineHeight: '16px',
          fontFamily: F,
        }}
      >
        {question}
      </span>

      {/* Quick-reply options */}
      {options && options.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {options.map((opt) => (
            <button
              key={opt}
              type="button"
              onClick={() => onAnswer(opt)}
              style={{
                display: 'flex',
                alignItems: 'center',
                borderRadius: 12,
                paddingBlock: 4,
                paddingInline: 10,
                backgroundColor: APP.bgCardBody,
                border: `1px solid ${ACCENT}40`,
                cursor: 'pointer',
                fontFamily: F,
                fontSize: 11,
                fontWeight: 500,
                color: ACCENT,
                lineHeight: '14px',
              }}
            >
              {opt}
            </button>
          ))}
        </div>
      )}

      {/* Free-text input */}
      {allowFreeInput && (
        <div style={{ display: 'flex', gap: 6 }}>
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && input.trim()) onAnswer(input.trim());
            }}
            placeholder="Type your answer…"
            style={{
              flex: 1,
              borderRadius: 4,
              paddingBlock: 4,
              paddingInline: 8,
              border: `1px solid ${APP.border}`,
              backgroundColor: APP.bgChatInput,
              color: APP.textPrimary,
              fontFamily: F,
              fontSize: 11,
              lineHeight: '14px',
              outline: 'none',
            }}
          />
          <button
            type="button"
            onClick={() => { if (input.trim()) onAnswer(input.trim()); }}
            disabled={!input.trim()}
            style={{
              borderRadius: 4,
              paddingBlock: 4,
              paddingInline: 10,
              backgroundColor: input.trim() ? ACCENT : '#E0DCD4',
              border: 'none',
              cursor: input.trim() ? 'pointer' : 'default',
              fontFamily: F,
              fontSize: 11,
              fontWeight: 600,
              color: '#FFFFFF',
              lineHeight: '14px',
            }}
          >
            Send
          </button>
        </div>
      )}

      {/* Cancel */}
      <button
        type="button"
        onClick={onCancel}
        style={{
          alignSelf: 'flex-start',
          borderRadius: 4,
          paddingBlock: 3,
          paddingInline: 8,
          backgroundColor: 'transparent',
          border: `1px solid ${APP.border}`,
          cursor: 'pointer',
          fontFamily: F,
          fontSize: 10,
          fontWeight: 500,
          color: APP.textCardDetail,
          lineHeight: '13px',
        }}
      >
        Skip
      </button>
    </div>
  );
}
